<template>
  <div class="pat-e">
    <div class="banner">
      <div class="banner-box">
        <div class="banner-text">
          <div class="slogan animate__animated animate__fadeInLeftBig">专为科技金融打造的智能决策引擎</div>

          <div class="title animate__animated animate__fadeInLeftBig">深眸</div>

          <div class="sub-title animate__animated animate__fadeInLeftBig">
            覆盖从营销获客到授信审批的全周期需求，提供Lite、Pro、Max三版企业智能体报告<br />
            ——逐层穿透企业画像，颗粒度由浅入深，让每一次决策都有据可依。<br />
          </div>

          <div class="tags-container animate__animated animate__fadeInLeftBig">
            <span v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
          </div>

          <div class="dimension-container animate__animated animate__fadeInLeftBig">
            <span class="dimension-title">多维数据支撑</span>
            <div class="dimension-content">
              <div class="dimension-item" v-for="(item, index) in dimensionList" :key="index">
                <i class="iconfont icon-gouxuan-mianxing"></i>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>

          <div class="btn-container animate__animated animate__fadeInUp">
            <div class="btn-top">
              <div class="exp-btn" @click="toRegister">
                <span>申请体验</span>
                <i class="iconfont icon-youjiantou-xianxing"></i>
              </div>
              <div class="use-btn" @click="toJump('z-axis')">
                <span>使用企业智能体报告</span>
                <i class="iconfont icon-youjiantou-xianxing"></i>
              </div>
            </div>

            <div class="jump-btn">
              <span @click="toJump('pat-e')">进入深眸系统</span>
            </div>
          </div>
        </div>

        <div class="banner-card animate__animated animate__fadeInRightBig">
          <div class="card-item" v-for="(item, index) in cardList" :key="index" :style="{ backgroundImage: `url(${item.bgUrl})` }">
            <div class="card-title">
              <img :src="item.iconUrl" alt="">
              <span>{{ item.title }}</span>
            </div>
            <div class="card-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'PatEV2',
  computed: {
    ...mapState(['isLogin'])
  },
  data () {
    return {
      tags: ['成长性评价', '访前尽调', '授信决策'],
      dimensionList: ['国家知识产权局全量权威数据', '460万+科技企业基因库', '专利、融资、人才多维穿透'],
      cardList: [
        {
          title: '快速筛查，精准营销',
          desc: '一页浓缩企业核心画像，助力客户经理高效筛选优质标的',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_快速筛查.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_快速筛查.png'
        },
        {
          title: '深度评估，支撑上报',
          desc: '穿透团队、产业、科技属性与经营实况，为企业评估与授信上报提供决策依据',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_深度评估.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_深度评估.png'
        },
        {
          title: '全面研判，辅助审批',
          desc: '全维度深度分析，内含风险预警与授信建议，让审批决策更有依据',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_全面研判.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_全面研判.png'
        }
      ]
    }
  },
  methods: {
    toRegister () {
      this.$router.push('/register')
      window.scrollTo(0, 0, 'smooth')
    },
    toJump (type) {
      if (type === 'pat-e') {
        window.open(`${process.env.VUE_APP_JUMPURL}enterprise/search?token=${this.$store.state.token}`)
      } else if (type === 'z-axis') {
        window.open(`${process.env.VUE_APP_ZAXISREPORTURL}zaxis-report/index?token=${this.$store.state.token}`)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.pat-e {
  .banner {
    width: 100%;
    min-width: $container-width;
    height: Translate(690px);
    background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_深眸.png") no-repeat;
    background-position: center center;
    background-size: cover;
    margin: 0 auto;

    &-box {
      width: $container-width;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }

    &-text {
      text-align: left;

      .slogan {
        position: absolute;
        top: Translate(58px);
        left: 0;
        @include Slogan();
      }

      .title {
        position: absolute;
        top: Translate(90px);
        left: 0;
        @include Text(60px, 500, 82px, #111, 'AlibabaPuHuiTiB');
      }

      .sub-title {
        width: Translate(680px);
        position: absolute;
        top: Translate(172px);
        left: 0;
        @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
      }

      .tags-container {
        position: absolute;
        top: Translate(234px);
        left: 0;
        display: flex;
        flex-wrap: wrap;
        gap: Translate(8px);

        span {
          @include Tag();
        }
      }

      .dimension-container {
        position: absolute;
        top: Translate(320px);
        left: 0;
        @include DimensionContainer();

        .dimension-title {
          @include Text(18px, 600, 25px, #111111, 'PingFangSC-Semibold');
        }

        .dimension-content {
          display: flex;
          flex-wrap: wrap;
          gap: Translate(8px) Translate(20px);
          margin-top: Translate(23px);

          .dimension-item {
            display: flex;
            align-items: center;
            gap: Translate(4px);

            i {
              font-size: Translate(14px);
              color: #91BAFF;
            }

            span {
              @include Text(14px, 400, 20px, #333333, 'PingFangSC-Regular');
            }
          }
        }
      }

      .btn-container {
        position: absolute;
        top: Translate(494px);
        left: 0;
        display: flex;
        flex-direction: column;
        gap: Translate(12px);

        .btn-top {
          display: flex;
          align-items: center;
          gap: Translate(20px);
        }

        .exp-btn {
          @include Button(180px, 60px, transparent, 16px, #fff);
          background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
          border-radius: Translate(30px);
          transition: all 0.15s ease-in;

          &:hover {
            opacity: 0.8;
            transform: translateY(Translate(-4px));
            box-shadow: 4px 10px 30px -4px rgba(0, 88, 255, 0.4);
          }

          i {
            font-size: Translate(22px);
            margin-left: Translate(6px);
            transition: transform 0.15s ease-in;
            @include ChevronIconAnimation();
          }
        }

        .use-btn {
          display: flex;
          align-items: center;
          cursor: pointer;
          @include Text(16px, 500, 22px, #0058FF, 'PingFangSC-Medium');

          i {
            font-size: Translate(20px);
            margin-left: Translate(4px);
            transition: transform 0.2s ease-in;
          }

          &:hover {
            opacity: 0.8;

            i {
              transform: translateX(Translate(3px));
            }
          }
        }

        .jump-btn {
          width: Translate(180px);
          display: flex;
          justify-content: center;

          span:first-child:not(:last-child) {
            @include Text(14px, 400, 20px, #333333, 'PingFangSC-Regular');
          }

          span:last-child {
            cursor: pointer;
            text-decoration: underline;
            @include Text(14px, 500, 20px, #0058FF, 'PingFangSC-Medium');

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }

    &-card {
      position: absolute;
      top: Translate(58px);
      right: 0;
      text-align: left;
      display: flex;
      flex-direction: column;
      gap: Translate(18px);

      .card-item {
        width: Translate(340px);
        height: Translate(120px);
        padding: Translate(20px);
        background-size: 100% 100%;
        box-sizing: border-box;
        border-radius: Translate(8px);
        transition: all 0.3s ease-in;

        &:hover {
          transform: translateY(Translate(-2px));
          box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
        }

        .card-title {
          display: flex;
          align-items: center;
          gap: Translate(6px);
          @include Text(18px, 600, 24px, #111111, 'PingFangSC-Semibold');

          img {
            width: Translate(18px);
            height: Translate(18px);
          }
        }

        .card-desc {
          margin-top: Translate(4px);
          @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
        }
      }
    }
  }
}
</style>
